import { render, staticRenderFns } from "./cocal-owner-match-add.vue?vue&type=template&id=626b62ae&"
import script from "./cocal-owner-match-add.vue?vue&type=script&lang=js&"
export * from "./cocal-owner-match-add.vue?vue&type=script&lang=js&"
import style0 from "./cocal-owner-match-add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports